import CardArtigoLg from "./cardArtigoLg";

export default function ListArtigos() {
    const isSmallScreen = window.innerWidth < 640;
    const dataListBlog = [
        {
            img: "../assets/articles/urban-lg.jpeg",
            tag: "Inovações e Tendências Tech",
            title: "Sua empresa nada em um oceano azul?",
            summary:
                "A Estratégia do Oceano Azul é uma abordagem empresarial que procura a inovação, a diferenciação e a criação de novos mercados, evitando a concorrência direta em mercados saturados. Concentra-se na criação de valor para os clientes e na execução eficaz para alcançar o sucesso sustentável. ",
            date: "2, Sept 2020",
            link: "/artigo?id=0#article",
        },

        {
            img: "../assets/articles/business-lg.jpeg",
            tag: "Inovações e Tendências Tech",
            title: "Business Agility e a Revolução na Implementação de ERPs: Como a Agilidade Está Transformando as Empresas",
            summary:
                "A Estratégia do Oceano Azul é uma abordagem empresarial que procura a inovação, a diferenciação e a criação de novos mercados, evitando a concorrência direta em mercados saturados. Concentra-se na criação de valor para os clientes e na execução eficaz para alcançar o sucesso sustentável.",
            date: "2, Sept 2020",
            link: "/artigo?id=1#article",
        },

        {
            img: "../assets/articles/leptop-lg.jpeg",
            tag: "Inovações e Tendências Tech",
            title: "A Revolução dos ERPs na Era da Nuvem",
            summary:
                "Nos últimos anos, os sistemas ERP (Enterprise Resource Planning) têm passado por uma verdadeira revolução, impulsionados por avanços tecnológicos que estão transformando a maneira como as empresas gerenciam suas operações. ",
            date: "2, Sept 2020",
            link: "/artigo?id=2#article",
        },
    ];

    var articles = [];

    function makeCards() {
        for (let i = 0; i < dataListBlog.length; i++) {
            let card = (
                <CardArtigoLg
                    key={i}
                    img={dataListBlog[i].img}
                    tag={dataListBlog[i].tag}
                    title={dataListBlog[i].title}
                    summary={dataListBlog[i].summary}
                    date={dataListBlog[i].date}
                    link={dataListBlog[i].link}
                    isMobile={isSmallScreen}
                />
            );

            articles.push(card);
        }
    }

    makeCards();

    return !isSmallScreen ?(
        <div id="article" className=" w-full bg-white p-[70px]">
            <div className="max-w-[1400px] m-auto">
                <div className="w-full flex flex-col gap-20 justify-center align-middle items-center">
                    {articles}
                </div>

                <div className=" mt-14 flex flex-row gap-5 justify-center">
                    <div className="h-14 w-14 bg-black text-white rounded-lg font-roboto font-medium text-base flex text-center items-center justify-center cursor-pointer">
                        <span>1</span>
                    </div>

                    <div className="h-14 w-14 bg-white text-black rounded-lg font-roboto font-medium text-base flex text-center items-center justify-center">
                        <span>...</span>
                    </div>

                    <div className="h-14 w-14 bg-white text-black rounded-lg font-roboto font-medium text-base flex text-center items-center justify-center cursor-pointer">
                        <span>Proximo</span>
                    </div>
                </div>
            </div>
        </div>
    ) : (
        <div className="bg-white w-full">            
            <div className="w-full flex flex-col justify-center align-middle items-center">
                {articles}
            </div>
        </div>
    );
}
